<template>
  <v-dialog
    :value="value"
    @input="input"
    width="800"
  >
    <JournalEntryForm
      class="journal-edit-dialog"
      v-model="journalEntry"
      title="Journaleintrag bearbeiten"
      @submit="update"
      @cancel="hide"
    />
  </v-dialog>
</template>

<script>
export default {
  name: 'EditJournalEntryDialog',
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    journalEntry: {
      type: Object,
      require: true,
    },
  },
  methods: {
    input(val) {
      this.$emit('input', val);
    },
    async update() {
      await this.journalEntry.update();
      this.$showSnackbar({ text: 'Erfolgreich aktualisiert.', color: 'success' });
      this.hide();
    },
    hide() {
      this.$emit('input', false);
    },
  },
};
</script>
